<div mat-dialog-header>
  <h1>{{ headline }}</h1>
</div>
<div #scroll mat-dialog-content class="dialog-container">
  <p>{{ content }}</p>
  <form [formGroup]="form">
    <mat-form-field class="fam-filter w-100">
      <mat-select
        placeholder="Select a Fund Family"
        [formControlName]="'family'"
      >
        @for (fam of fundFamilies; track fam) {
          <mat-option [value]="fam.ID">
            {{ fam.Name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </form>
</div>
<mat-dialog-actions class="row buttons">
  <button type="button" mat-raised-button color="accent" (click)="save()">
    {{ confirm }}
  </button>
  <button type="button" mat-raised-button (click)="cancel()">Cancel</button>
</mat-dialog-actions>
